import { UniversalCouponInput } from '@fff-web/fff-payments';
import { useReactivatePlanDataContext } from '../../utils/ContextProviders/ReactivatePlanDataContext';

const ReactivateCouponInputContainer = () => {
  const {
    discount,
    couponData,
    error,
    handleCallCouponApi,
    loading: couponLoading,
    coupon,
    handleOnChange: handleOnChangeCoupon,
  } = useReactivatePlanDataContext();

  const discountFormatted = discount ? `-$${discount.toFixed(2)}` : '';

  return (
    <UniversalCouponInput
      couponData={couponData}
      error={error}
      handleCallCouponApi={handleCallCouponApi}
      loading={couponLoading}
      coupon={coupon}
      handleOnChange={handleOnChangeCoupon}
      variant="secondary"
      label="Promo Code/Gift Card"
      placeholder="Promo Code/Gift Card"
      discount={discountFormatted}
    />
  );
};

export default ReactivateCouponInputContainer;
